import {styled} from "@mui/material/styles"

export const StandardFacetListSelectLabel = styled("span")`
    font-weight: ${({theme}) => `${theme.colours.font.secondary.medium.weight}`};
    font-family: ${({theme}) => `${theme.colours.typography.subtitle2.fontFamily}, ${theme.colours.font.default}`};
`
export default StandardFacetListSelectLabel
